import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { SubscriptionService } from "src/app/Services/subscription.service";

export type CreatorPlanConfirmResult =
  | false
  | {
      confirmed: true;
      effectivePlanId: string;
      userType: string;
      requiresPaidCreation: boolean;
    };

@Component({
  selector: "app-creator-plan-confirm-dialog",
  templateUrl: "./creator-plan-confirm-dialog.component.html",
  styleUrls: ["./creator-plan-confirm-dialog.component.scss"],
})
export class CreatorPlanConfirmDialogComponent {
  isAssigning = false;

  constructor(
    public dialogRef: MatDialogRef<CreatorPlanConfirmDialogComponent>,
    private subscriptionService: SubscriptionService,
    private toastr: ToastrService
  ) {
    this.dialogRef.disableClose = true;
  }

  join(): void {
    if (this.isAssigning) {
      return;
    }

    this.isAssigning = true;
    this.subscriptionService.assignCreator().subscribe({
      next: (result) => {
        this.dialogRef.close({
          confirmed: true,
          effectivePlanId: result.effectivePlanId,
          userType: result.userType,
          requiresPaidCreation: result.requiresPaidCreation,
        } as CreatorPlanConfirmResult);
      },
      error: (err) => {
        this.isAssigning = false;
        const message =
          err?.error?.message ||
          "Could not activate Creator plan. Please try again.";
        this.toastr.error(message);
      },
    });
  }

  cancel(): void {
    if (this.isAssigning) {
      return;
    }
    this.dialogRef.close(false);
  }
}
